module.exports = __webpack_public_path__ + "img/icon_wdjhk.a2a4dc28.png";